import React, { PureComponent } from 'react';
import { Button } from 'antd';

export type ProductGoodsModifySavePayload = {
    row: any;
};

type ModifySaveHandler = (payload: ProductGoodsModifySavePayload) => void;

let modifySaveHandler: ModifySaveHandler | null = null;

export const registerProductGoodsModifySaveHandler = (handler: ModifySaveHandler | null) => {
    modifySaveHandler = handler;
};

/**
 * 行内编辑「保存」按钮：下架改上架时由父组件接管预检/执行逻辑
 */
export class ProductGoodsModifySaveButton extends PureComponent<any> {
    handleClick = () => {
        const { row } = this.props;
        if (!modifySaveHandler || !row) {
            return;
        }
        modifySaveHandler({ row });
    };

    render() {
        const { row, className, disabled } = this.props;
        if (!row || !row._modify) {
            return null;
        }
        return (
            <Button
                type="link"
                className={className}
                disabled={disabled}
                onClick={this.handleClick}
            >
                保存
            </Button>
        );
    }
}
